import {ConditionLine} from "../ConditionLine";
import {EmptyComparator} from "./EmptyComparator";
import {StandardComparator} from "./StandardComparator";
import { ComposedComparator } from "./ComposedComparator";
import {ComparatorBase} from "./ComparatorBase";
import {DateComparator} from "./DateComparator";
import {MultipleOptionsComparator} from "./MultipleOptionsComparator";
import {NumericComparator} from "./NumericComparator";

export class ComparatorFactory {
    public static GetComparator(conditionLine:ConditionLine){

        switch (conditionLine.props.ConditionLineOptions.Type as any) {
            case ConditionLineTypeEnum.None:
                return new EmptyComparator().Initialize(conditionLine as any);
            case ConditionLineTypeEnum.Custom:
                let customComparator= new StandardComparator();
                customComparator.Initialize(conditionLine);
                return customComparator;
            case ConditionLineTypeEnum.Standard:
                let comparator:ComparatorBase=null;
                switch(conditionLine.props.ConditionLineOptions.SubType)
                {
                    case "Text":
                        comparator= new StandardComparator();
                        break;
                    case "None":
                        comparator =new EmptyComparator();
                        break;
                    case "Address":
                    case "Name":
                        comparator= new ComposedComparator()
                        break;
                    case "Date":
                        comparator=new DateComparator();
                        break;
                    case "Multiple":
                        comparator=new MultipleOptionsComparator();
                        break;
                    case "Number":
                        comparator=new NumericComparator();
                        break;



                }
                if(comparator!=null)
                    comparator.Initialize(conditionLine as any);
                return comparator;



        }

    }
}


export enum ConditionLineTypeEnum {
    Standard='Standard',
    None='None',
    Custom='Custom'

}
